

var Model = require("../types/Model.js");
var window = require("global");
var document = window.document;
var navigator = window.navigator;

var networkinterface = window.networkinterface;

module.exports = Model({
	name: "networkstatus",
	init: init,
	uninit: uninit,
	triggers: triggers,

	_online_change_handler: null,
	_offline_change_handler: null,

	checkConnection: checkConnection,
	checkIP: checkIP
});

function init() {
	this._online_change_handler = handle_online.bind(this);
	this._offline_change_handler = handle_offline.bind(this);

	if(document){
		document.addEventListener("online", this._online_change_handler, false);
		document.addEventListener("offline", this._offline_change_handler, false);
	}

	this.push({
		IP: "",
		type: "",
		connected: true
	});
	this.checkIP();
	this.checkConnection();
}

function uninit() {
	if(document){
		document.removeEventListener("online", this._online_change_handler, false);
		document.removeEventListener("offline", this._offline_change_handler, false);
	}
}

function triggers() {
	return {
		"networkstatus": handle_connection_query
	};
}

function handle_online() {
	this.dispatch("online");
	this.extend({
		connected: true
	});
}

function handle_offline() {
	this.dispatch("offline");
	this.extend({
		connected: false
	});
}

function handle_connection_query() {
	try {
		this.checkConnection();
		this.checkIP();
	} catch (e) {
		console.error(e);
	}
}

function checkConnection() {
	if (!navigator || !navigator.connection) return;

	var networkState = navigator.connection.type;

	var states = {
		"unknown": "Unknown connection",
		"ethernet": "Ethernet connection",
		"wifi": "WiFi connection",
		"2g": "Cell 2G connection",
		"3g": "Cell 3G connection",
		"4g": "Cell 4G connection",
		"cellular": "Cell generic connection",
		"none": "No network connection"
	};

	this.extend({
		type: states[networkState]
	});
}

function checkIP() {
	if (!networkinterface) return;

	networkinterface.getIPAddress(handleIP.bind(this), function (e) {
		console.error("IP check failed.", e);
	});
}

function handleIP(ip) {
	this.extend({
		IP: ip
	});
}
